import React, { Component } from 'react';
import { Link, withRouter, Redirect } from 'react-router-dom';
import * as routes from '../../constants/routes';
import { auth, db, firebase } from '../../firebase';
import logo from '../../assets/logo.png';
import UploadButton from 'react-upload-button-v2';
import SignUp from './SignUp.css';
import httpreq from '../utils/Api';
import * as apiRoutes from '../../constants/apiRoutes';


const SignUpPage = ({ history }) =>
  <div>
    <SignUpForm history={history} />
  </div>

const INITIAL_STATE = {
  accountType: '',
  lastName: '',
  firstName: '',
  displayName: '',
  email: '',
  passwordOne: '',
  passwordTwo: '',
  error: null,
  profilePicUrl: '',
  picture: '',
  isUploading: false,
  progress: 0,
  profilePicFile: null,
  profilePicLocalURL: '',
  securityPin: '',
  dbSecPin: '',
};

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

class SignUpForm extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  onSubmit = (event) => {
  const {
    email,
    firstName,
    lastName,
    passwordOne,
    accountType,
  } = this.state;
  const displayName = firstName + " " + lastName;
  const {
    history,
  } = this.props;
  
  auth.doCreateUserWithEmailAndPassword(email, passwordOne)
    .then(authUser => {
    const user = {
      id: authUser.user.uid,
      accountType: accountType,
      firstName,
      lastName,
      displayName,
      email
    }

    db.doCreateUser(user)
      .then(() => {
      //on db create succes upload image if available
      if (this.state.profilePicFile) {
        this.imageUpload(this.state.profilePicFile, user.id);
      }

      if (user.accountType == 1) {
        history.push(routes.SELECT_INTERESTS);
      }
      else {
        history.push('/');
      }

      })
      .catch(error => {
      this.setState(byPropKey('error', error));
      });
    })
    .catch(error => {
    this.setState(byPropKey('error', error));
    });

  event.preventDefault();
  }

  handlePictureInputChange = (e) => {
    this.setState({
      profilePicLocalURL: URL.createObjectURL(e.files[0]),
      profilePicFile: e.files[0],
    })
  }

  handleUploadStart = () => this.setState({ isUploading: true, progress: 0 });
  
  handleUploadError = (error) => {
    this.setState({ isUploading: false });
    console.error(error);
  }

  imageUpload = (file, storageName) => {
    const storageRef = firebase.storage().ref().child('profileImages');
    const uploadTask = storageRef.child(storageName).put(file);
    uploadTask.on('state_changed', function (snapshot) {
      // Observe state change events such as progress, pause, and resume
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      switch (snapshot.state) {
      case firebase.storage.TaskState.PAUSED: // or 'paused'
        break;
      case firebase.storage.TaskState.RUNNING: // or 'running'
        break;
      }
    }, function (error) {
      // Handle unsuccessful uploads
      console.error("upload error", error);
    }, function () {
      // Handle successful uploads on complete
      // For instance, get the download URL: https://firebasestorage.googleapis.com/...
      uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
      db.updateProfilePicUrl(storageName, downloadURL)
      .then(() => {})
      .catch((err) => {console.error("profilePicUpdate error", err)});
      });
    });
  }

  handleTypeChange = (event) => {
    this.setState({accountType: event.target.value});
  }

  handleSecurityPin = (event) => {
    this.setState({securityPin: event.target.value});
    if(event.target.value.length > 0) {
      const body = {
        pin: event.target.value
      };
  
      httpreq({
        method: 'POST',
        url: apiRoutes.PIN_VERIFY,
        data: body,
        headers: {'Content-type': 'application/json'}
      })
      .then(res => {
        this.setState({dbSecPin: res['valid']});
      }) 
    }
  }

  handleUploadSuccess = (filename) => {
  this.setState({ picture: filename, progress: 100, isUploading: false });
  firebase.storage().ref('images').child(filename).getDownloadURL().then(url => this.setState({ profilePicUrl: url }));
  };

  render() {
  const {
    username,
    lastName,
    email,
    passwordOne,
    passwordTwo,
    error,
    accountType,
    securityPin,
    dbSecPin
  } = this.state;

  const isInvalid =
    passwordOne !== passwordTwo ||
    passwordOne === '' ||
    email === '' ||
    lastName === '' ||
    username === '' ||
    ((securityPin === '' || !dbSecPin) && (accountType == 1));

  return (
    <div className="signUpWrapper">
    <div className="text-center title-container">
      <img src={logo} />
      <h4>Create a new account to Kinnected or <Link className="orange-font" to={routes.SIGN_IN}>Sign in</Link></h4>
    </div>
    <div className="signUpCard">
      <div className="tabs">
      <div className="tab">
        <input type="radio" value="1" id="tab-1" name="tab-group-1" onChange={this.handleTypeChange} />
        <label htmlFor="tab-1">Professional</label>
      </div>
      <span className="vertical-line"></span>
      <div className="tab">
        <input type="radio" value="0" id="tab-2" name="tab-group-1" defaultChecked={true} onChange={this.handleTypeChange} />
        <label htmlFor="tab-2">Student</label>
      </div>
      </div>
      <div className="card-body">

      <div className="text-center photo-upload-btn">
        <UploadButton
        type="file"
        
        className="btn btn-outline-dark circle btn-circle"
        onChange={(e) => this.handlePictureInputChange(e)}
        id="photo"
        >
        <div
          style={
          { backgroundImage: `url(${this.state.profilePicLocalURL})`, backgroundSize: "cover", backgroundRepeat: "no-repeat" }
          }
          className="circle btn-circle"
        >
          {!this.state.profilePicLocalURL &&
          <div>
          <p>ADD A</p>
          <p>PHOTO</p> 
          </div>
          }
        </div>

        </UploadButton>
      </div>
      <form className="signUpForm" onSubmit={this.onSubmit}>
        <div className="firstNameContainer">
        <div className="firstNameLabel">
          <span id="basic-addon1">First Name</span>
        </div>
        <div className="firstNameField">
          <input
          value={username}
          onChange={event => this.setState(byPropKey('firstName', event.target.value))}
          type="text"
          placeholder="First Name"
          className="form-control"
          />
        </div>
        </div>
        <div className="lastNameContainer">
        <div className="lastNameLabel">
          <span id="basic-addon1">Last Name</span>
        </div>
        <div className="lastNameField">
          <input
          value={lastName}
          onChange={event => this.setState(byPropKey('lastName', event.target.value))}
          type="text"
          placeholder="Last Name"
          className="form-control"
          />
        </div>
        </div>
        <div className="emailContainer">
        <div className="emailLabel">
          <span id="basic-addon1">Email</span>
        </div>
        <div className="emailField">
          <input
          value={email}
          onChange={event => this.setState(byPropKey('email', event.target.value))}
          type="text"
          placeholder="Email Address"
          className="form-control"
          />
        </div>
        </div>

        <div className="passwordContainer">
        <div className="passwordLabel">
          <span id="basic-addon1">Password</span>
        </div>
        <div className="passwordField">
          <input
          value={passwordOne}
          onChange={event => this.setState(byPropKey('passwordOne', event.target.value))}
          type="password"
          placeholder="Password"
          className="form-control"
          />
        </div>
        </div>
        <div className="confirmContainer">
        <div className="confirmLabel">
          <span id="basic-addon1">Confirm</span>
        </div>
        <div className="confirmField">
          <input
          value={passwordTwo}
          onChange={event => this.setState(byPropKey('passwordTwo', event.target.value))}
          type="password"
          placeholder="Confirm Password"
          className="form-control"
          />
        </div>
        </div>
        {this.state.accountType == 1 &&
        <div className="pinContainer">
        <div className="pinLabel">
          <span id="basic-addon1">Security Pin</span>
        </div>
        <div className="pinField">
          <input
          value={securityPin}
          onChange={event => this.handleSecurityPin(event)}
          type="password"
          placeholder="Security Pin"
          className="form-control"
          />
        </div>
        </div>
         }
        <div className="text-center">
        {this.state.accountType == 1 ?
        <button 
          className="btn btn-lg kinnected-orange" 
          id="create-button" 
          disabled={isInvalid} 
          type="submit"
        >
          Next
        </button>
        :
        <button 
          className="btn btn-lg kinnected-orange" 
          id="create-button" 
          disabled={isInvalid} 
          type="submit"
        >
          Create
        </button>
        }
        </div>

        <div className="termsAndCondition">
        <p> By creating an account, I accept the Terms of Use
         and Privacy Policy</p>
        </div>

        {error && <p>{error.message}</p>}

      </form>
      </div>
    </div>
    </div>
  );
  }
}

const SignUpLink = () =>
  <span>
  <Link className="orange-font" to={routes.SIGN_UP}>create an account</Link>
  </span>

export default withRouter(SignUpPage);

export {
  SignUpForm,
  SignUpLink,
};


// WEBPACK FOOTER //
// ./src/components/account/SignUp.js